import { formatRuleId, useFlag } from '@spotify/plugin-confidence-flags-react';
import { useSetResolvedTitle } from '@spotify/plugin-confidence-projects-react';

import { parseRuleParentFlagName } from '../resourceUri';
import { PreviewShell, RuleItem } from './components';

interface RuleArtifactPreviewProps {
  resourceName: string;
}

export const RuleArtifactPreview = ({
  resourceName,
}: RuleArtifactPreviewProps) => {
  const flagName = parseRuleParentFlagName(resourceName);

  const { flag, isLoading, error } = useFlag({
    name: flagName ?? '',
    skip: !flagName,
  });

  const rule = flag?.rules.find(r => r.name === resourceName);
  const previewError = error ?? (!isLoading && !rule ? 'not-found' : undefined);

  useSetResolvedTitle(formatRuleId(resourceName));

  return (
    <PreviewShell loading={isLoading} error={previewError}>
      {rule && <RuleItem rule={rule} />}
    </PreviewShell>
  );
};
